import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { AlertCircle } from 'lucide-react';

interface IWritingStyleTextInputProps {
  sampleText: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isSubmitting: boolean;
  error?: string;
  wordCount: number;
}

export function WritingStyleTextInput({
  sampleText,
  onChange,
  isSubmitting,
  error,
  wordCount,
}: IWritingStyleTextInputProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="sampleText">Sample Text * (minimum 300 words)</Label>
      <Textarea
        id="sampleText"
        placeholder="Paste a text sample that represents the writing style you want to analyze..."
        value={sampleText}
        onChange={onChange}
        disabled={isSubmitting}
        className={`min-h-[200px] ${error ? 'border-destructive' : ''}`}
      />
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">
          Word count: {wordCount} / 300
          {wordCount >= 300 && wordCount <= 500 && ' (adequate)'}
          {wordCount > 500 && ' (excellent!)'}
        </span>
        {error && (
          <p className="text-destructive flex items-center gap-1">
            <AlertCircle className="h-3 w-3" />
            {error}
          </p>
        )}
      </div>
    </div>
  );
}
